<template>
  <v-tooltip bottom relative>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on">info</v-icon>
    </template>
    <div v-html="tip"></div>
  </v-tooltip>
</template>

<script>
export default {
  props:{
    tip:{
      type:String,
      required:true
    },
    small:{
      type:Boolean,
      default:false
    }
  }
}
</script>

<style>

</style>